"use client"

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { FreeMode, Navigation } from 'swiper/modules';
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils';
import { Skeleton } from '../ui/skeleton';
import MaxWidthContainer from './max-width-container';
import CustomLabel from '../ui/custom-label';

export default function TripSliderLoader({title}: {title?: string}) {
    return (
        <section className="py-10 md:py-12 relative overflow-hidden">
            <MaxWidthContainer className='space-y-5 relative'>
                {title && <CustomLabel label={title} />}
                <div className='relative h-full w-full'>
                    <Swiper
                        breakpoints={{
                            200: {
                                slidesPerView: 1,
                                spaceBetween: 12
                            },
                            350: {
                                slidesPerView: 1.1,
                                spaceBetween: 10
                            },
                            420: {
                                slidesPerView: 1.3,
                                spaceBetween: 16
                            },
                            460: {
                                slidesPerView: 1.4,
                                spaceBetween: 16
                            },
                            550: {
                                slidesPerView: 1.7,
                                spaceBetween: 16
                            },
                            650: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },
                            750: {
                                slidesPerView: 2.3,
                                spaceBetween: 20
                            },
                            850: {
                                slidesPerView: 2.6,
                                spaceBetween: 20
                            },
                            1000: {
                                slidesPerView: 3,
                                spaceBetween: 16
                            },
                            1200: {
                                slidesPerView: 3.3,
                                spaceBetween: 20
                            },
                            1400: {
                                slidesPerView: 4,
                                spaceBetween: 24
                            },
                        }}
                        navigation={{
                            prevEl: `.loader-prev`,
                            nextEl: `.loader-next`,
                        }}
                        freeMode={true}
                        modules={[Navigation, FreeMode]}
                        className="mySwiper"
                    >
                        {Array.from({ length: 8 }).map((data, i) => (
                            <SwiperSlide key={i} className='pb-6'>
                                <Skeleton className='rounded-lg overflow-hidden h-96 w-full max-w-96 mx-auto bg-gray-300' />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button className={cn('absolute top-1/2 -translate-x-1/2 left-0 -translate-y-1/2 z-20 lg:h-8 lg:w-8 md:h-7 md:w-7 h-6 w-6 p-0.5 lg:p-1 rounded-full bg-white text-custom-primary hover:bg-custom-primary hover:text-white transition-all duration-300 ease-in-out shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hover:shadow-none disabled:hidden hidden md:block loader-prev')}><ChevronLeft className='h-full w-full' /></button>
                    <button className={cn('absolute top-1/2 translate-x-1/2 right-0 -translate-y-1/2 z-20 lg:h-8 lg:w-8 md:h-7 md:w-7 h-6 w-6 p-0.5 lg:p-1 rounded-full bg-white text-custom-primary hover:bg-custom-primary hover:text-white transition-all duration-300 ease-in-out shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hover:shadow-none disabled:hidden hidden md:block loader-next')}><ChevronRight className='h-full w-full' /></button>
                </div>
            </MaxWidthContainer>
        </section>
    )
}
